import React from 'react';
import { Row, Button, Col, Avatar } from 'antd';
import styles from './AppDetailList.less';

class List extends React.Component {
  render() {
    const { BasicInfo } = this.props;
    return (
      <div className={styles.appDetailList}>
        <div className={styles.listTop}>
          <Row className={styles.msgContainer}>
            <Col span={4} offset={1}>
              <Avatar
                src={BasicInfo.icon ? '/api' + BasicInfo.icon : ''}
                shape="square"
                size="large"
                icon="android-o"
                style={{ backgroundColor: '#97c021' }}
              />
            </Col>
            <Col span={18} offset={1}>
              <p>名称 : {BasicInfo['name']}</p>
              <p>当前版本 : {BasicInfo['version']}</p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/DeviceInfo/AppDetailList.js